import script from "./ClassMatesDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassMatesDetails.vue?vue&type=script&setup=true&lang=js"

import "./ClassMatesDetails.vue?vue&type=style&index=0&id=8de963fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8de963fe"]])

export default __exports__